import React, { Component } from "react";
import UploadService from "../services/file-upload.service";
import AuthService from "../../AuthService";

export default class UploadImages extends Component {
    constructor(props) {
        super(props);
        this.selectFile = this.selectFile.bind(this);
        this.upload = this.upload.bind(this);

        this.state = {
            currentFile: undefined,
            previewImage: undefined,
            progress: 0,
            message: "",

            imageInfos: [],
            imageUrl: AuthService.getUrl('/files/'+this.props.bateauId+'.jpg'),
            imageHash: Date.now()
        };
    }

    selectFile(event) {
        this.setState({
            currentFile: event.target.files[0],
            previewImage: URL.createObjectURL(event.target.files[0]),
            progress: 0,
            message: ""
        });
    }

    upload() {
        this.setState({
            progress: 0,
            imageUrl: ''
        });

        UploadService.upload(this.props.bateauId, this.state.currentFile, (event) => {
            this.setState({
                progress: Math.round((100 * event.loaded) / event.total),
            });
        })
            .then((response) => {
                this.setState({
                    message: response.data.message,
                    imageUrl: AuthService.getUrl('/files/'+this.props.bateauId+'.jpg'),
                    imageHash: Date.now
                });
            })
            .catch((err) => {
                this.setState({
                    progress: 0,
                    message: "L'image n'a pas pu être uploadée. Celle-ci ne doit pas dépasser 10MB et une résolution supérieure à 5760×3840",
                    currentFile: undefined,
                });
            });
    }

    render() {
        const {
            currentFile,
            previewImage,
            progress,
            message,
            imageInfos,
        } = this.state;

        return (
            <div>
                <img className="boat-img" src={`${this.state.imageUrl}?${this.state.imageHash}`}/>
                <div className="row">
                    <div className="col-8">
                        <label className="btn btn-default p-0">
                            <input type="file" accept="image/*" onChange={this.selectFile} />
                        </label>
                    </div>

                    <div className="col-4">
                        <button
                            className="btn btn-success btn-sm"
                            disabled={!currentFile}
                            onClick={this.upload}
                        >
                            Upload
                        </button>
                    </div>
                </div>

                {currentFile && (
                    <div className="progress my-3">
                        <div
                            className="progress-bar progress-bar-info progress-bar-striped"
                            role="progressbar"
                            aria-valuenow={progress}
                            aria-valuemin="0"
                            aria-valuemax="100"
                            style={{ width: progress + "%" }}
                        >
                            {progress}%
                        </div>
                    </div>
                )}

                {previewImage && (
                    <div>
                        <img className="preview" src={previewImage} alt="" />
                    </div>
                )}

                {message && (
                    <div style={{color: 'red'}} className="alert alert-secondary mt-3" role="alert">
                        <h1>{message}</h1>
                        <a href="http://www.imageoptimizer.net/Pages/Home.aspx" target="_blank">Cliquer i&ccedil;i pour rendre l'image optimis&eacute;e</a>
                    </div>
                )}

                <div className="card mt-3">
                    <ul className="list-group list-group-flush">
                        {imageInfos &&
                        imageInfos.map((img, index) => (
                            <li className="list-group-item" key={index}>
                                <a href={img.url}>{img.name}</a>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        );
    }
}
